import gql from "graphql-tag";

export const encodeCollection = gql`
  mutation encodeCollection(
    $input: EncodeCollectionInput!) {
    encodeCollection(input: $input) {
      project {
        id
        collections {
          id
          index
          name
          archived
          syncing
          syncedAt
          encoding
          encodedAt
          changed
          changedAt
          searchableFields {
            field
            model
          }
        }
      }
    }
  }
`;

export const encodeCollectionOptions = {
  name: "encodeCollection",
};
